"use strict";
//  Copyright 2018, Venkat Peri.
//
//  Permission is hereby granted, free of charge, to any person obtaining a
//  copy of this software and associated documentation files (the
//  "Software"), to deal in the Software without restriction, including
//  without limitation the rights to use, copy, modify, merge, publish,
//  distribute, sublicense, and/or sell copies of the Software, and to permit
//  persons to whom the Software is furnished to do so, subject to the
//  following conditions:
//
//  The above copyright notice and this permission notice shall be included
//  in all copies or substantial portions of the Software.
//
//  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
//  OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
//  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
//  NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
//  DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
//  OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
//  USE OR OTHER DEALINGS IN THE SOFTWARE.
Object.defineProperty(exports, "__esModule", { value: true });
var objectInspect = require("object-inspect");
var State_1 = require("../State");
var types_1 = require("../types");
var StringHelper_1 = require("../util/StringHelper");
/**
 * @hidden
 */
var Event = /** @class */ (function () {
    /**
     * Constructor
     * @param context - Event data
     * @param extra - Extra event data.
     */
    function Event(context, extra) {
        this.context = context;
        this.extra = extra;
        /**
         * Event's priority when enqueued
         * @type {Priority}
         */
        this.priority = types_1.Priority.Normal;
    }
    Object.defineProperty(Event.prototype, "contextString", {
        /**
         * @hidden
         *  Serialize event context to a string
         *
         * @return {string}
         */
        get: function () {
            return StringHelper_1.dataToString(this.context);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Event.prototype, "route", {
        /**
         * @hidden
         * Serialize this event to a route
         * @return {string}
         */
        get: function () {
            return this.typeRoute + "#" + this.contextRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Event.prototype, "contextRoute", {
        /**
         * @hidden
         * Serialize context to route path
         * @return {string}
         */
        get: function () {
            return StringHelper_1.dataToRoute(this.context);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Event.prototype, "typeRoute", {
        /**
         * @hidden
         * Serialize type to route path
         * @return {EventType}
         */
        get: function () {
            return this.type;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @hidden
     * Comparator based on priorities
     *
     * @return {number}
     * @param a
     * @param b
     */
    Event.comparator = function (a, b) {
        return a.priority - b.priority;
    };
    /**
     * @hidden
     * Maps event to route for given state
     * @param state
     * @return {string}
     */
    Event.prototype.toRoute = function (state) {
        return this.route + "#" + State_1.stateRoute(state);
    };
    /**
     * @hidden
     * Convert to displayable string
     *
     * @return {string}
     */
    Event.prototype.toString = function () {
        // return `${_.upperFirst(
        //     this.type)}@${Priority[this.priority]} ${this.contextString}`
        return [StringHelper_1.upperFirst(this.type) + "@" + types_1.Priority[this.priority],
            objectInspect({
                context: this.context
            })].join(' ');
    };
    return Event;
}());
exports.default = Event;
//# sourceMappingURL=Event.js.map